import { loadable } from '../../../utils';

export const Basic = loadable(() => import('./Basic'), {});
export const ImportWizard = loadable(() => import('./ImportWizard'), {});
